import React, { useState } from "react";
import whatsappIcon from "../static/img/what-app-icon.png";
import BoxNavigation from "../box_button/BoxButtonNavigation.js";
import Language from "../box_button/language_button.js";
import CustomMenuFooter from "../footer/custom_menu_footer.js";

import BoxNavigationFooter from "../box_button/BoxNavigationFooter.js";

import { useTranslation } from "react-i18next";

import Logo from "../static/img/logo-desktop.png";

const FooterComponent = ({
    activePage,
    onNavigationChange,
    lang,
    setLang,
    casinoSections,
}) => {
    const [menus, setMenus] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);

    const { t } = useTranslation();

    const fetchMenus = async () => {
        try {
            const fetchedMenus = [
                {
                    menu_name: "footer",
                    menu_type: "mobile",
                    selection: "Sport",
                },
                {
                    menu_name: "footer1",
                    menu_type: "mobile",
                    selection: "Casino",
                },
                {
                    menu_name: "footerCUSTOM1",
                    menu_type: "custom",
                    selection: "Info",
                },
                {
                    menu_name: "footerCUSTOM2",
                    menu_type: "custom",
                    selection: "About us",
                },
            ];
            setMenus(fetchedMenus);
            setIsLoaded(true);
        } catch (error) {
            console.error("Error fetching menus:", error);
        }
    };

    const LoadMenu = () => {
        if (!isLoaded) {
            fetchMenus();
        }
    };

    LoadMenu();

    return (
        <div className="footer-fixed">
            <div className="accordion-plus_footer">
                <a
                    className="title-footer collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#footer"
                    aria-expanded="false"
                >
                    {t("Info")}
                </a>
            </div>

            <div className="footer collapse" id="footer">
                <div className="footer-section">
                    <div className="brand_Box">
                        <img
                            src={`/assets/img/logo-desktop.png?ts=${new Date().getTime()}`}
                            alt="Nome-sito"
                        />

                        <a href="#" className="affiliation_link">
                            {t("Membership")}
                        </a>
                    </div>

                    <div className="button-category-f row">
                        {menus.map((menu) => (
                            <CustomMenuFooter
                                key={menu.menu_name}
                                menu_name={menu.menu_name}
                                type={menu.menu_type}
                                selection={menu.selection}
                                lang={lang}
                                activePage={activePage}
                                onNavigationChange={onNavigationChange}
                                casinoSections={casinoSections}
                            />
                        ))}

                        <div className="col">
                            <BoxNavigationFooter />
                        </div>
                    </div>

                    {/* <div className='row license-payment'>
          <div className='col'>
          <div className="payment-method">
            <p>{t('Payment_methods')}:</p>
            <PaymentMethods />
          </div>
          </div>

          <div className='col'>
        <LicenseBox />

        </div>
          </div> */}

                    <div className="row sub-footer">
                        <div className="col">
                            <div className="copy_box">
                                <div className="left_copy">
                                    © {t("Copyright")} Amatic365 - 2025
                                </div>
                                <div className="right_copy">
                                    <span>+18</span>
                                    {t("Play_responsibly")}
                                </div>
                            </div>
                        </div>

                        <div className="col">
                            <div className="footer-barNav">
                                <div className="btn-socialGroup"></div>

                                <div className="language">
                                    <Language setLang={setLang} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// PaymentMethods component
const PaymentMethods = () => {
    return (
        <div className="payment-method-icons">
            <svg
                viewBox="0 0 750 471"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            >
                <path
                    d="M52.8846154,28.2035928 C39.6085397,28.2035928 28.8461538,38.7262417 28.8461538,51.7065868 L28.8461538,419.293413 C28.8461538,432.273758 39.6085397,442.796407 52.8846154,442.796407 L697.115385,442.796407 C710.39146,442.796407 721.153846,432.273758 721.153846,419.293413 L721.153846,51.7065868 C721.153846,38.7262417 710.39146,28.2035928 697.115385,28.2035928 L52.8846154,28.2035928 Z M52.8846154,0 L697.115385,0 C726.322751,-5.0099645e-15 750,23.1498275 750,51.7065868 L750,419.293413 C750,447.850173 726.322751,471 697.115385,471 L52.8846154,471 C23.6772488,471 3.41607085e-15,447.850173 0,419.293413 L0,51.7065868 C-3.41607085e-15,23.1498275 23.6772488,5.0099645e-15 52.8846154,0 Z"
                    id="outline"
                />
                <g id="Logo" transform="translate(60.000000, 139.000000)">
                    <polygon
                        id="Shape"
                        points="222.597614 191.12625 254.442205 4.26252273 305.375795 4.26252273 273.50925 191.12625"
                    ></polygon>
                    <path
                        d="M457.520795,8.29261364 C447.429341,4.50688636 431.61825,0.444340909 411.871568,0.444340909 C361.544114,0.444340909 326.092295,25.7884773 325.790659,62.1117955 C325.507159,88.9622045 351.099477,103.940932 370.419477,112.879295 C390.244432,122.038159 396.910023,127.879977 396.815523,136.058523 C396.689523,148.584068 380.983432,154.306568 366.343568,154.306568 C345.957341,154.306568 335.127068,151.474432 318.400568,144.497659 L311.837114,141.527114 L304.688523,183.359114 C316.585023,188.57475 338.583477,193.094523 361.424795,193.328386 C414.964295,193.328386 449.721205,168.274432 450.116386,129.486477 C450.30825,108.229705 436.738432,92.0520682 407.353705,78.7161136 C389.550477,70.07175 378.647659,64.3034318 378.763159,55.55025 C378.763159,47.7831136 387.991705,39.4776136 407.931205,39.4776136 C424.587068,39.2189318 436.651568,42.8509773 446.051932,46.6367045 L450.616568,48.7930227 L457.520795,8.29261364"
                        id="Shape"
                    />
                    <path
                        d="M588.586568,4.26252273 L549.229705,4.26252273 C537.037295,4.26252273 527.91375,7.59006818 522.55875,19.7586136 L446.915795,191.006932 L500.399932,191.006932 C500.399932,191.006932 509.145477,167.981386 511.123295,162.926114 C516.967977,162.926114 568.924841,163.006295 576.353114,163.006295 C577.876568,169.547795 582.550023,191.006932 582.550023,191.006932 L629.811477,191.006932 L588.586568,4.26252273 Z M526.143068,124.92375 C530.355477,114.157432 546.43575,72.6881591 546.43575,72.6881591 C546.135068,73.1854773 550.616659,61.8693409 553.189159,54.8534318 L556.632205,70.96425 C556.632205,70.96425 566.384795,115.569205 568.42275,124.922795 L526.143068,124.922795 L526.143068,124.92375 Z"
                        id="Path"
                    />
                    <path
                        d="M179.361477,4.26252273 L129.496023,131.689568 L124.183023,105.793705 C114.900068,75.94125 85.9773409,43.5993409 53.6430682,27.4073864 L99.2388409,190.828432 L153.127705,190.766386 L233.313341,4.26252273 L179.361477,4.26252273"
                        id="Path"
                    />
                    <path
                        d="M82.9686136,4.26252273 L0.838568182,4.26252273 L0.188522727,8.15038636 C64.0848409,23.6178409 106.364523,60.9968864 123.914795,105.909205 L106.056205,20.0382955 C102.973023,8.20575 94.0308409,4.67488636 82.9686136,4.26252273"
                        id="Shape"
                    />
                </g>
            </svg>

            <svg
                viewBox="0 0 750 471"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            >
                <path
                    d="M52.8846154,28.2035928 C39.608341,28.2035928 28.8461538,38.7262291 28.8461538,51.7065868 L28.8461538,419.293413 C28.8461538,432.274332 39.6079531,442.796407 52.8846154,442.796407 L697.115385,442.796407 C710.391473,442.796407 721.153846,432.273953 721.153846,419.293413 L721.153846,51.7065868 C721.153846,38.7266083 710.391085,28.2035928 697.115385,28.2035928 L52.8846154,28.2035928 Z M52.8846154,0 L697.115385,0 C726.322376,0 750,23.1501941 750,51.7065868 L750,419.293413 C750,447.850476 726.322653,471 697.115385,471 L52.8846154,471 C23.6766623,471 0,447.850746 0,419.293413 L0,51.7065868 C0,23.1499239 23.6769386,0 52.8846154,0 Z"
                    id="Rectangle-1"
                />
                <g id="Group" transform="translate(54.000000, 161.000000)">
                    <path
                        d="M109.272795,8.45777679 C101.24875,2.94154464 90.7780357,0.176741071 77.8606518,0.176741071 L27.8515268,0.176741071 C23.8915714,0.176741071 21.7038036,2.15719643 21.2882232,6.11428571 L0.972553571,133.638223 C0.761419643,134.890696 1.07477679,136.03617 1.90975893,137.077509 C2.73996429,138.120759 3.78416964,138.639518 5.03473214,138.639518 L28.7887321,138.639518 C32.9550446,138.639518 35.2450357,136.663839 35.6653929,132.701973 L41.2905357,98.3224911 C41.4959375,96.6563482 42.2286964,95.3016518 43.4792589,94.2584018 C44.7288661,93.2170625 46.2918304,92.5358929 48.1671964,92.2234911 C50.0425625,91.9139554 51.8109286,91.7582321 53.4808929,91.7582321 C55.1460804,91.7582321 57.124625,91.8633214 59.4203482,92.0706339 C61.7103393,92.2789018 63.170125,92.3801696 63.7958839,92.3801696 C81.7145625,92.3801696 95.7793304,87.3311071 105.991143,77.2224732 C116.198179,67.1176607 121.307429,53.1063929 121.307429,35.1829375 C121.307429,22.8903571 117.293018,13.9826071 109.272795,8.45777679 Z M83.4877054,46.7484911 C82.4425446,54.0426429 79.7369732,58.8328036 75.3614375,61.1256607 C70.9849464,63.4213839 64.7340446,64.5630357 56.6087321,64.5630357 L46.2937411,64.8754375 L51.6083929,31.43125 C52.0230179,29.1412589 53.3767589,27.9948304 55.6705714,27.9948304 L61.6109821,27.9948304 C69.9416964,27.9948304 75.9881518,29.1957143 79.7388839,31.5879286 C83.4877054,33.985875 84.7382679,39.0406696 83.4877054,46.7484911 Z"
                        id="Shape"
                    />
                    <path
                        d="M637.025455,0.176741071 L613.899125,0.176741071 C611.600536,0.176741071 610.24775,1.32316964 609.835036,3.61602679 L589.518411,133.639179 L589.205054,134.263982 C589.205054,135.311054 589.621589,136.296027 590.457527,137.234187 C591.285821,138.170438 592.332893,138.639518 593.581545,138.639518 L614.211527,138.639518 C618.16575,138.639518 620.354473,136.663839 620.775786,132.701973 L641.092411,4.86276786 L641.092411,4.55227679 C641.091455,1.63557143 639.732938,0.176741071 637.025455,0.176741071 Z"
                        id="Shape"
                    />
                    <path
                        d="M357.599732,50.4963571 C357.599732,49.4569286 357.18033,48.4652679 356.352991,47.5290179 C355.517054,46.5918125 354.576982,46.1208214 353.539464,46.1208214 L329.471152,46.1208214 C327.174473,46.1208214 325.300063,47.1678929 323.845054,49.2457946 L290.714223,98.0072232 L276.961857,51.1230714 C275.915741,47.7917411 273.62575,46.1208214 270.086152,46.1208214 L246.640732,46.1208214 C245.596527,46.1208214 244.659321,46.5908571 243.831027,47.5290179 C242.995089,48.4652679 242.580464,49.4578839 242.580464,50.4963571 C242.580464,50.9167143 244.612509,57.0606161 248.674688,68.9376161 C252.736866,80.8174821 257.112402,93.6326429 261.801295,107.385964 C266.490188,121.13642 268.936857,128.433437 269.14608,129.261732 C252.058562,152.601107 243.51767,165.103866 243.51767,166.768098 C243.51767,169.479402 244.870455,170.832188 247.580804,170.832188 L271.648161,170.832188 C273.939107,170.832188 275.813518,169.792759 277.274259,167.70817 L356.976839,52.684125 C357.39242,52.2704554 357.599732,51.5443839 357.599732,50.4963571 Z"
                        id="Shape"
                    />
                    <path
                        d="M581.704545,46.1208214 L557.947679,46.1208214 C555.029063,46.1208214 553.262607,49.5601071 552.638759,56.4367679 C547.214241,48.1050982 537.323429,43.9330536 522.942438,43.9330536 C507.940464,43.9330536 495.174027,49.5601071 484.655545,60.8123036 C474.13133,72.0645 468.872089,85.2990625 468.872089,100.508348 C468.872089,112.80475 472.465188,122.597161 479.652339,129.887491 C486.841402,137.185464 496.479045,140.827286 508.567179,140.827286 C514.608857,140.827286 520.755625,139.574813 527.006527,137.076554 C533.257429,134.576384 538.149813,131.244098 541.698964,127.07492 C541.698964,127.284143 541.48592,128.220393 541.07225,129.886536 C540.652848,131.5565 540.447446,132.808973 540.447446,133.637268 C540.447446,136.975286 541.798321,138.637607 544.511536,138.637607 L566.079679,138.637607 C570.031991,138.637607 572.32867,136.661929 572.951563,132.700063 L585.768634,51.1221161 C585.974036,49.8715536 585.660679,48.7270357 584.830473,47.6837857 C583.99358,46.6434018 582.955107,46.1208214 581.704545,46.1208214 Z M540.915571,107.696455 C535.60283,112.906018 529.19525,115.509366 521.694741,115.509366 C515.649241,115.509366 510.756857,113.845134 507.004214,110.509027 C503.251571,107.180563 501.376205,102.595804 501.376205,96.7566607 C501.376205,89.0517054 503.981464,82.5352143 509.191027,77.2224732 C514.394857,71.9087768 520.860714,69.2519286 528.570446,69.2519286 C534.400036,69.2519286 539.245607,70.9715714 543.104295,74.4079911 C546.955339,77.8472768 548.887071,82.5887143 548.887071,88.6323036 C548.886116,96.1328125 546.229268,102.489759 540.915571,107.696455 Z"
                        id="Shape"
                    />
                    <path
                        d="M226.64033,46.1208214 L202.885375,46.1208214 C199.963893,46.1208214 198.196482,49.5601071 197.570723,56.4367679 C191.944625,48.1050982 182.04617,43.9330536 167.877268,43.9330536 C152.874339,43.9330536 140.109813,49.5601071 129.588464,60.8123036 C119.06425,72.0645 113.805009,85.2990625 113.805009,100.508348 C113.805009,112.80475 117.400018,122.597161 124.58908,129.887491 C131.778143,137.185464 141.41292,140.827286 153.500098,140.827286 C159.331598,140.827286 165.378054,139.574813 171.628,137.076554 C177.878902,134.576384 182.880196,131.244098 186.630929,127.07492 C185.794991,129.575089 185.380366,131.763813 185.380366,133.637268 C185.380366,136.975286 186.734107,138.637607 189.4435,138.637607 L211.009732,138.637607 C214.965866,138.637607 217.260634,136.661929 217.886393,132.700063 L230.700598,51.1221161 C230.906,49.8715536 230.594554,48.7270357 229.763393,47.6837857 C228.929366,46.6434018 227.888027,46.1208214 226.64033,46.1208214 Z M185.850402,107.851223 C180.53575,112.962384 174.02117,115.509366 166.316214,115.509366 C160.269759,115.509366 155.425143,113.845134 151.781411,110.509027 C148.132902,107.180563 146.311036,102.595804 146.311036,96.7566607 C146.311036,89.0517054 148.914384,82.5352143 154.125857,77.2224732 C159.331598,71.9087768 165.791723,69.2519286 173.504321,69.2519286 C179.335821,69.2519286 184.180438,70.9715714 188.039125,74.4079911 C191.891125,77.8472768 193.820946,82.5887143 193.820946,88.6323036 C193.820946,96.3420357 191.164098,102.751527 185.850402,107.851223 Z"
                        id="Shape"
                    />
                    <path
                        d="M464.337964,8.45777679 C456.314875,2.94154464 445.847027,0.176741071 432.926777,0.176741071 L383.231964,0.176741071 C379.06183,0.176741071 376.768018,2.15719643 376.354348,6.11428571 L356.039634,133.638223 C355.8285,134.890696 356.139946,136.03617 356.975884,137.077509 C357.804179,138.120759 358.85125,138.639518 360.100857,138.639518 L385.729268,138.639518 C388.229438,138.639518 389.89558,137.286732 390.729607,134.577339 L396.357616,98.3224911 C396.563018,96.6563482 397.293866,95.3016518 398.544429,94.2584018 C399.794991,93.2170625 401.356045,92.5358929 403.233321,92.2234911 C405.108688,91.9139554 406.876098,91.7582321 408.547973,91.7582321 C410.212205,91.7582321 412.191705,91.8633214 414.483607,92.0706339 C416.776464,92.2789018 418.238161,92.3801696 418.859143,92.3801696 C436.781643,92.3801696 450.8445,87.3311071 461.055357,77.2224732 C471.265259,67.1176607 476.369732,53.1063929 476.369732,35.1829375 C476.370687,22.8903571 472.357232,13.9826071 464.337964,8.45777679 Z M432.301973,59.8750982 C427.717214,63.0000714 420.839598,64.5620804 411.673902,64.5620804 L401.670357,64.8744821 L406.985964,31.4302946 C407.398679,29.1403036 408.751464,27.993875 411.048143,27.993875 L416.67233,27.993875 C421.255179,27.993875 424.900821,28.2021429 427.614036,28.6177232 C430.319607,29.037125 432.926777,30.3364107 435.426946,32.5241786 C437.929027,34.7119464 439.177679,37.891375 439.177679,42.0576875 C439.177679,50.8106696 436.882911,56.7472589 432.301973,59.8750982 Z"
                        id="Shape"
                    />
                </g>
            </svg>
        </div>
    );
};

// LicenseBox component
const LicenseBox = () => {
    const { t } = useTranslation();
    const licenseUrl = process.env.REACT_APP_LICENSE_URL;

    return (
        <a
            href={licenseUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="license-box-link"
        >
            <div className="license-box">
                <h3>{t("License")}</h3>
                <div className="img_licenseBox">
                    <img
                        src="https://seal.cgcb.info/1c0246df-1aa7-485a-a24c-21ae5e730000"
                        alt="License Seal"
                    />
                </div>
                <div className="text_licenseBox">
                    This is to certify that 1x2play.bet is operated by Games &
                    More B.V, a company incorporated under the laws of Curaçao
                    with Company Number 149948 (0) and licensed by the Curaçao
                    Gaming Authority to offer games of chance under license
                    number OGL/2023/121/0086 in accordance with the National
                    Ordinance on Games of Chance (Landsverordening op de
                    kansspelen, P.B. 2024, no. 157).
                </div>
            </div>
        </a>
    );
};

export default FooterComponent;
